import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PointsListComponent} from './point-list/point-list.component';
import {PaymentInfoComponent} from './payment-info/payment-info.component';

@Component({
  selector: 'app-points-purchase',
  templateUrl: 'points-purchase.component.html',
  styleUrls: ['points-purchase.component.scss'],
  imports: [CommonModule, PointsListComponent, PaymentInfoComponent]
})
export class PointsPurchaseComponent {
}
